import * as mod from 'common-ui/lib/common/CommonElements/Headings/H4Element';

export default mod.default;
